var $ = require('jquery');
var TorsoView = require('backbone-torso/modules/View');

/**
 * Default View for the trigger of the accordion widget
 *
 */
module.exports = TorsoView.extend({
  tagName: 'span',

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this view
   */
  initialize: function(options) {
    if (options.accordionTriggerTemplate) {
      this.template = options.accordionTriggerTemplate ;
    } else if (options.accordionTriggerMessageKey) {
      this.template = $.i18n.prop(options.accordionTriggerMessageKey);
    } else {
      throw 'Either accordionTriggerView, accordionTriggerTemplate, or accordionTriggerMessageKey must be provided when instantiating an accordion.';
    }
  }
});
